import React, { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";

/**
 * Iter-450 — offline notice for the till PWA. Staff phones drop wifi
 * mid-shift; instead of silent stale data, show a sticky amber bar
 * ("connection lost — reconnecting") while offline and a brief green
 * "back online" flash on recovery. Driven by the browser's
 * online/offline events (react-query refetches automatically once the
 * network returns).
 */
export default function TillOfflineBar() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [justBack, setJustBack] = useState(false);

  useEffect(() => {
    let t;
    const onOffline = () => {
      setOffline(true);
      setJustBack(false);
    };
    const onOnline = () => {
      setOffline(false);
      setJustBack(true);
      t = setTimeout(() => setJustBack(false), 4000);
    };
    window.addEventListener("offline", onOffline);
    window.addEventListener("online", onOnline);
    return () => {
      window.removeEventListener("offline", onOffline);
      window.removeEventListener("online", onOnline);
      clearTimeout(t);
    };
  }, []);

  if (!offline && !justBack) return null;

  return offline ? (
    <div
      data-testid="till-offline-bar"
      className="sticky top-0 z-50 flex items-center justify-center gap-2 rounded-xl bg-amber-500 text-white text-sm font-bold px-4 py-2.5 shadow-card"
      role="status"
    >
      <WifiOff className="w-4 h-4" />
      Connection lost — reconnecting… the till will catch up automatically.
    </div>
  ) : (
    <div
      data-testid="till-online-bar"
      className="sticky top-0 z-50 flex items-center justify-center gap-2 rounded-xl bg-emerald-600 text-white text-sm font-bold px-4 py-2.5 shadow-card"
      role="status"
    >
      <Wifi className="w-4 h-4" />
      Back online — everything&apos;s up to date.
    </div>
  );
}
